




























import Vue from 'vue'
import { ActionInterface, ExpanderLikeElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'ExpanderLikeEl',
  props: {
    templateItemData: {
      type: Object as () => ExpanderLikeElInterface,
      required: true
    }
  },
  computed: {
    mainStyle (): string {
      return this.templateItemData.totalLook
        ? 'background: #b4ff00;'
        : ''
    }
  },
  methods: {
    handleActionClick (action: ActionInterface): void {
      if (action.uri !== undefined) {
        this.getView(action.view, action.content || action.uri, null, action.jumpOnCloseUri)
      }
    }
  },
  mounted () {
    if (this.templateItemData.totalLook) {
      const element = this.$refs.expanderLike as HTMLDivElement

      if (element.parentElement && element.parentElement.parentElement) {
        const backgroundColor = '#b4ff00'
        element.parentElement.style.background = backgroundColor
        element.parentElement.parentElement.classList.remove('itemBackground')
        element.parentElement.parentElement.style.background = backgroundColor
      }
    }
  }
})
